import React from 'react';
import { MenuItem } from 'material-ui/Menu';
import { ListItemIcon } from 'material-ui/List';
import TextField from 'material-ui/TextField/TextField';

class DropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: props.label !== null ? props.label : 'Drop Down Menu',
            selection: props.selection !== null ? props.selection : 0,
            menuOptions: props.menuOptions !== null ? props.menuOptions : ([
                {
                    label: 'Option 1',
                    value: 0,
                    icon: null
                }
            ])
        };
    }

    handleTFChange = event => {
        let val = event.target.value;
        if (event.ctrlKey) {
            val = '';
        }
        this.handleClose(val);
        if (this.props.onChange) {
            this.props.onChange(val, event);
        }
    };

    handleClose = (item) => {
        this.setState({
            selection: (item === 'clear' ? '' : item)
        });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.selection) {
            this.setState({ selection: nextProps.selection });
        }
    }

    render() {
        // const inputLabelProps = this.props.InputLabelProps || {};
        return (
            <div>
                <TextField
                    select
                    style={{ width: this.props.width || '180px' }}
                    label={this.state.label}
                    name={this.state.label}
                    placeholder={'Introduzca ' + this.state.label}
                    value={this.state.selection}
                    error={this.props.error !== undefined ? this.props.error : false}
                    InputLabelProps={Object.assign({
                        shrink: true,
                    }, this.props.InputLabelProps)}
                    onChange={this.handleTFChange}>
                    {this.state.menuOptions.map((option, index) =>
                        <MenuItem key={index + '' + option.label} value={option.value || option.code}>
                            {option.icon || null ? <ListItemIcon>{option.icon}</ListItemIcon> : ''}
                            {option.label}
                        </MenuItem>
                    )
                    }
                </TextField>
            </div>
        );
    }
}
export default DropDownMenu;


// WEBPACK FOOTER //
// ./src/ui/DropDownMenu.js